import Scope from './Scope';
export default class TrackingScope extends Scope {
    params;
    attribs;
    usedPathParams = new Set();
    usedQueryParams = new Set();
    usedAttribs = new Set();
    usedLoaders = new Map();
    constructor(params, attribs) {
        super();
        this.params = params;
        this.attribs = attribs;
    }
    getParamValue(name, source) {
        this[source === 'path' ? 'usedPathParams' : 'usedQueryParams'].add(name);
        return this.params[source][name];
    }
    getAttribute(name) {
        this.usedAttribs.add(name);
        return this.attribs[name];
    }
    addLoader(loader, result) {
        this.usedLoaders.set(loader, result);
    }
}
